<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Crear Asesor Técnico</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row justify-content-center">
        <seller-form :server-errors="serverErrors" @save="saveSeller"></seller-form>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import SellerForm from './Forms/SellerForm';
import swal from 'sweetalert2';

export default {
  name: 'SellersCreate',
  components: {
    RouteBreadCrumb,
    SellerForm,
  },

  data() {
    return {
      serverErrors: [],
    };
  },

  methods: {
    saveSeller(seller) {
      this.serverErrors = [];
      this.$services
        .resource('sellers')
        .create(seller)
        .then((res) => {
          swal({
            title: 'Listo!',
            text: 'El asesor técnico fue creado.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success',
            type: 'success',
          }).then(() => this.$router.push({ name: 'SellersList' }));
        })
        .catch((errors) => {
          this.serverErrors = errors;
        });
    },
  },
};
</script>
